import { render, staticRenderFns } from "./tetris.vue?vue&type=template&id=de349ada&"
import script from "./tetris.vue?vue&type=script&lang=js&"
export * from "./tetris.vue?vue&type=script&lang=js&"
import style0 from "./tetris.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports